export default "__VITE_ASSET__DjoIxrgV__"